import {FILTERS_ARGS} from "@/app/exercise/modules/trainings/core/training-const";

export class ChapterFiltersDTO {
  constructor(queries = {}) {
    this.license_type = queries[FILTERS_ARGS.LICENSE_TYPE]
    this.tenant = queries[FILTERS_ARGS.TENANT]
  }
}